import React from 'react';

const Timer = ({ timeRemaining, totalTime }) => {
  const percentage = (timeRemaining / totalTime) * 100;
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  let colorClass = 'timer-normal';
  if (percentage <= 20) {
    colorClass = 'timer-danger';
  } else if (percentage <= 50) {
    colorClass = 'timer-warning';
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 text-center">
      <div className="text-sm font-semibold text-gray-600 mb-2">
        Zbývající čas
      </div>
      <div className={`text-5xl font-bold ${colorClass} mb-4`}>
        {minutes}:{seconds.toString().padStart(2, '0')}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div
          className={`h-3 rounded-full transition-all duration-1000 ${
            percentage <= 20
              ? 'bg-red-500'
              : percentage <= 50
              ? 'bg-yellow-500'
              : 'bg-green-500'
          }`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default Timer;
